// extracted by mini-css-extract-plugin
export default {"FolderView":"FolderView_FolderView__2k9oN","OpacityBreak":"FolderView_OpacityBreak__YBP4c"};